export default `---
slug: greece
country: Greece
countryCode: GRC
continent: Europe
year: 2015
title: "Greece"
description: "The cradle of civilization — islands, olive oil, and impossibly blue water."
thumbnail: /images/travels/GRC/greece_thumb.jpg
relatedLinks: []
---
![greece](/images/travels/GRC/greece_thumb.jpg)

*Story coming soon — stay tuned!*

I visited Greece and it was an incredible experience. Full story and photos are being written up and will appear here soon.
`;
